/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  Export1Params,
  GetInfo14PathParameters,
  List2Params,
  Remove4Params,
  TableDataInfo,
  TravelLocalSpecialtyDish
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 删除地方特色菜
 */
const remove4 = (
    params: Remove4Params,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/localSpecialty/remove`, method: 'POST',
        params
    },
      );
    }
  /**
 * @summary 查询地方特色菜列表
 */
const list2 = (
    params: List2Params,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/travel18/localSpecialty/list`, method: 'POST',
        params
    },
      );
    }
  /**
 * @summary 导出地方特色菜列表
 */
const export1 = (
    params: Export1Params,
 ) => {
      return orvalMutator<void>(
      {url: `/travel18/localSpecialty/export`, method: 'POST',
        params
    },
      );
    }
  /**
 * @summary 修改保存地方特色菜
 */
const editSave2 = (
    travelLocalSpecialtyDish: TravelLocalSpecialtyDish,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/localSpecialty/edit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: travelLocalSpecialtyDish
    },
      );
    }
  /**
 * @summary 新增保存地方特色菜
 */
const addSave3 = (
    travelLocalSpecialtyDish: TravelLocalSpecialtyDish,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/localSpecialty/add`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: travelLocalSpecialtyDish
    },
      );
    }
  /**
 * @summary 获取地方特色菜详情
 */
const getInfo14 = (
    { specialtyId }: GetInfo14PathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/localSpecialty/${specialtyId}`, method: 'GET'
    },
      );
    }
  return {remove4,list2,export1,editSave2,addSave3,getInfo14}};
export type Remove4Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['remove4']>>>
export type List2Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['list2']>>>
export type Export1Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['export1']>>>
export type EditSave2Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['editSave2']>>>
export type AddSave3Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['addSave3']>>>
export type GetInfo14Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['getInfo14']>>>
